export enum DamagedProductModal {
  DAMAGED_PRODUCT_SUCCESS = "DAMAGED_PRODUCT_SUCCESS",
}
